"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenSharingStream = getScreenSharingStream;
exports.syncScreenShareAudioWithStage = syncScreenShareAudioWithStage;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _DisplaySurfaceTypes = require("@studio/constants/DisplaySurfaceTypes");
var _screenShareHelper = require("@cvent/studio-agora/screenShare/screenShareHelper");
var _getSources = require("@studio/sources/getSources");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var loggerName = 'ScreenShare-Helper';
var logger = new _StudioLogger.StudioLogger(loggerName);
/**
 * This method will log the shared display surface and returns media stream to handle screen sharing.
 * @returns the media stream, the type of screen share and if audio is included in the stream.
 */
function getScreenSharingStream() {
  return _getScreenSharingStream.apply(this, arguments);
}
/**
 * Mutes the local screen share audio while the screen share is off stage
 * and unmutes it while it is on stage. A failed mute is logged, not thrown,
 * so it never stops the caller.
 * @param {Object} params
 * @param {Object} params.audioTrack - The published screen share audio track
 * @param {string} params.screenShareAttendeeId - The screen share attendee ID (`<attendeeId>#content`)
 * @param {Object} params.program - The current program
 */
function _getScreenSharingStream() {
  _getScreenSharingStream = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var stream, hasAudio, videoTracks, settings, shareType, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return navigator.mediaDevices.getDisplayMedia({
            video: true,
            audio: true
          });
        case 1:
          stream = _context.v;
          hasAudio = stream.getAudioTracks().length > 0;
          videoTracks = stream.getVideoTracks();
          if (!(videoTracks.length === 0)) {
            _context.n = 2;
            break;
          }
          stopTracks(stream);
          throw new Error('Unable to start a screenshare: no video track was returned.');
        case 2:
          settings = videoTracks[0].getSettings();
          logger.info('Screen share stream settings.', {
            streamSettings: settings
          });

          // Edge case: The stream exists but is blank, screen share failed for an unknown reason
          if (!(!settings.width || !settings.height || settings.width === 0 || settings.height === 0)) {
            _context.n = 3;
            break;
          }
          stopTracks(stream);
          throw new Error('Unable to start a screenshare.');
        case 3:
          shareType = _DisplaySurfaceTypes.DISPLAY_SURFACE_TYPES[settings.displaySurface] || settings.displaySurface || 'unknown';
          logger.info("User shared ".concat(shareType).concat(hasAudio ? ' with audio.' : ' without audio.'), {
            shareType: shareType,
            hasAudio: hasAudio
          });
          return _context.a(2, {
            stream: stream,
            hasAudio: hasAudio,
            shareType: shareType
          });
        case 4:
          _context.p = 4;
          _t = _context.v;
          logger.error("Error while creating screen sharing stream.", {
            error: _t
          });
          throw _t;
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 4]]);
  }));
  return _getScreenSharingStream.apply(this, arguments);
}
function syncScreenShareAudioWithStage(_x) {
  return _syncScreenShareAudioWithStage.apply(this, arguments);
}
function _syncScreenShareAudioWithStage() {
  _syncScreenShareAudioWithStage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref) {
    var audioTrack, screenShareAttendeeId, program, shouldMute, muteAction, isMuteChanged, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          audioTrack = _ref.audioTrack, screenShareAttendeeId = _ref.screenShareAttendeeId, program = _ref.program;
          shouldMute = !(0, _getSources.isScreenShareOnStage)(program, screenShareAttendeeId);
          muteAction = shouldMute ? 'mute' : 'unmute';
          _context2.p = 1;
          _context2.n = 2;
          return (0, _screenShareHelper.setScreenShareAudioMuted)(audioTrack, shouldMute);
        case 2:
          isMuteChanged = _context2.v;
          if (isMuteChanged) {
            logger.info("Screen share audio ".concat(muteAction, "d for: ").concat(screenShareAttendeeId));
          }
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          logger.error("Screen share audio ".concat(muteAction, " failed for: ").concat(screenShareAttendeeId), {
            errorMessage: _t2.message
          });
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return _syncScreenShareAudioWithStage.apply(this, arguments);
}
var stopTracks = function stopTracks(stream) {
  stream.getTracks().forEach(function (track) {
    return track.stop();
  });
};